/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';
import Loading from 'react/components/Loading';
import SurveyListItem from './SurveyListItem';
import { getResourceTo } from 'react/utils/utils';

class SurveyList extends React.Component {
  componentDidMount() {
    this.fetchPhotoAlbums();
  }

  componentDidUpdate() {
    this.fetchPhotoAlbums();
  }

  fetchPhotoAlbums() {
    const { fetchPhotoAlbumsAction, shouldFetchPhotoAlbums, routeId, stopId } = this.props;

    if (shouldFetchPhotoAlbums) {
      fetchPhotoAlbumsAction({ routeId, stopId });
    }
  }

  noSurveysFeedbackText() {
    const { stopId } = this.props;

    return stopId !== 'without-stop' ? getResourceTo('stopSurveyModal.fetchSurveysEmpty') :
      getResourceTo('routeSurveyModal.fetchSurveysEmpty');
  }

  renderSurveys = () => {
    const { surveyList, routeId, stopId } = this.props;
    return (
      surveyList?.size ? (
        surveyList.map((survey) =>
          <SurveyListItem
            key={`survey${survey.get('id')}`}
            survey={survey}
            routeId={routeId}
            stopId={stopId}
          />
        )
      ) : (
        <div className="route-survey-modal__survey-list__no-survey">
          <div className="img"></div>
          <span>
            {this.noSurveysFeedbackText()}
          </span>
        </div>
      )
    );
  }

  render() {
    const { isLoadingPhotoAlbums } = this.props;
    return (
      <div data-testid="route-survey-modal__survey-list" className="route-survey-modal__survey-list">
        {isLoadingPhotoAlbums ? <Loading height="100%" /> : this.renderSurveys()}
      </div>
    );
  }
}

SurveyList.propTypes = {
  // state
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  surveyList: PropTypes.object.isRequired,
  isLoadingPhotoAlbums: PropTypes.bool.isRequired,
  shouldFetchPhotoAlbums: PropTypes.bool.isRequired,
  // actions
  fetchPhotoAlbumsAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, { routeId, stopId }) => ({
  surveyList: selectors.getSurveyList(state, String(routeId), String(stopId)),
  isLoadingPhotoAlbums: selectors.getIsLoadingPhotoAlbums(state, String(routeId), String(stopId)),
  shouldFetchPhotoAlbums: selectors.shouldFetchPhotoAlbums(state, String(routeId), String(stopId))
});

const mapDispatchToProps = {
  fetchPhotoAlbumsAction: actionCreators.fetchPhotoAlbums
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyList);
